"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgOilQuart32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h32v32H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M8.898 6h5.618v4.238l7.39 5.158a2.794 2.794 0 0 1 1.196 2.292v8.194c0 .618-.5 1.118-1.118 1.118H10.016c-.617 0-1.118-.5-1.118-1.118V6Zm3.298 5.507 8.082 5.579c.252.173.402.46.402.766v5.863a.745.745 0 0 1-.745.745h-7.87a.745.745 0 0 1-.745-.745V11.967a.559.559 0 0 1 .876-.46Zm3.847 5.216a.093.093 0 0 0-.132 0c-.08.088-1.983 2.173-1.983 3.41 0 1.269 1.042 2.027 2.05 2.027 1.006 0 2.048-.758 2.048-2.028 0-1.236-1.902-3.32-1.983-3.409ZM8.898 8.53h5.6", stroke: "currentColor" })] })) }))); };
exports.default = SvgOilQuart32;
